import AuthClient from './lib/client';
export * from './lib/client';
export * from './lib/recoveryKey';
export default AuthClient;
//# sourceMappingURL=browser.js.map